document.addEventListener('DOMContentLoaded', () => {
    handleResponsiveFormInputs();         // Run on load
    window.addEventListener('resize', handleResponsiveFormInputs); // Re-run on window resize
    submitJobsearchFormOnFiltersChange();
    initLocationMultiselect();
    ps_jobkeyworddropdown();
    ps_joblisting_accessibility();
   // makingJoblistingCardClickable();
});
function handleResponsiveFormInputs() {
    const isMobile = window.innerWidth <= 768;

    const mobileContainer = document.querySelector('.mobile-only-form-boxes');
    const desktopContainer = document.querySelector('.desktop-only-form-boxes');

    if (mobileContainer) {
        const mobileInputs = mobileContainer.querySelectorAll('select, input');
        mobileInputs.forEach(input => {
            input.disabled = !isMobile;
        });
    }

    if (desktopContainer) {
        const desktopInputs = desktopContainer.querySelectorAll('select, input');
        desktopInputs.forEach(input => {
            input.disabled = isMobile;
        });
    }
}


function submitJobsearchFormOnFiltersChange() {
    const form = document.querySelector(".page-template-joblisting-template #ps-job-searchbox-form");

    if (!form) return;

    // Attach change listeners to all relevant fields
    const selectors = [
        '.page-template-joblisting-template select[name="location[]"]',
        '.page-template-joblisting-template input[name="location[]"]',
        '.page-template-joblisting-template select[name="contract_type[]"]',
        '.page-template-joblisting-template input[name="contract_type[]"]',
        '.page-template-joblisting-template select[name="sortby"]'
    ];

    selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
            el.addEventListener("change", function () {
                form.submit();
            });
        });
    });
}


function initLocationMultiselect() {
    $(".ps-wp-form-group .multi-select-form-control").each(function () {
        const select = this; // Native DOM select element
        const ariaLabel = select.getAttribute('aria-label');

        // Initialize Select2
        $(select).select2({
            width: 'style',
            placeholder: ariaLabel, // Use aria-label as placeholder
            allowClear: Boolean(select.dataset.allowClear),
            closeOnSelect: false // Common for multi-selects to stay open
        });

        // Ensure tabindex=0 is set on the Select2 container's selection element
        setTimeout(() => {
            $(select).next('.select2-container')
                .find('.select2-selection')
                .attr('tabindex', '0');
        }, 0); // Delay to ensure Select2 has initialized
    });
}



function ps_jobkeyworddropdown() {
    // Get the input, dropdown items, and clear button
    const inputField = document.getElementById('ask-question');
    const dropdownItems = document.querySelectorAll('.dropdown-item');
    const clearButton = document.querySelector('.clear-button');
  
    // Function to check input and validate if it matches any dropdown item
    function handleInput(event) {
      if (event.key === 'Enter') {
        const inputValue = inputField.value.toLowerCase(); // Get input value
        let matchFound = false;
  
        // Loop through the dropdown items to check for a match
        dropdownItems.forEach((item) => {
          const dropdownText = item.textContent.toLowerCase();
  
          // Check if the input exactly matches any dropdown item
          if (dropdownText === inputValue) {
            matchFound = true; // A match is found
          }
        });
  
        // If no match is found, prevent clearing the input
        if (!matchFound) {
          console.log("No match found, keeping input text");
          // Prevent form submission or input clearing here
          event.preventDefault(); // Prevent default action (e.g., form submission or clearing)
        }
      }
    }
  
    // Event listener for input keydown (Enter key)
    if(inputField){

        inputField.addEventListener('keydown', handleInput);
    }
  
    // Clear the input when the clear button is clicked
    if(clearButton){
        clearButton.addEventListener('click', () => {
          inputField.value = ''; // Clear the input field
          inputField.focus(); // Return focus to input field
        });
    }
  }
  

function ps_joblisting_accessibility(){
const jobListings = document.querySelectorAll('.ps-wp-job-listing');

// Make each job listing focusable by adding tabindex
jobListings.forEach(job => {
    job.setAttribute('tabindex', '0'); // 0 makes it focusable in the tab order
});

document.querySelectorAll('.ps-wp-job-listing').forEach(jobListing => {
    // Make each job listing focusable
    jobListing.setAttribute('tabindex', '0');

    // Add event listener for focus
    jobListing.addEventListener('focus', function() {

        // Change border color on focus
      //  jobListing.style.borderColor = '#007bff';

        // Show the job details section
        // const jobExtra = jobListing.querySelector('.ps-wp-job-extra');
        // if (jobExtra) {
        //     jobExtra.style.maxHeight = 'max-content'; // Ensure content is visible
        //     jobExtra.style.opacity = '1'; // Make it visible
        // }

        // Hide the bottom button
        const bottomBtn = jobListing.querySelector('.ps-wp-bottom-btn');
        if (bottomBtn) {
            //bottomBtn.style.display = 'none'; // Hide the bottom button
        }
    });

    // Add event listener for blur (when focus is lost)
    // jobListing.addEventListener('blur', function() {
    //     // Reset styles when focus is lost
    //     jobListing.style.outline = 'none';
    //     jobListing.style.boxShadow = 'none';
    //    // jobListing.style.borderColor = '#ccc'; // Default border color

    //     // Hide the job details section when focus is lost
    //     // const jobExtra = jobListing.querySelector('.ps-wp-job-extra');
    //     // if (jobExtra) {
    //     //     jobExtra.style.maxHeight = '0'; // Hide the content
    //     //     jobExtra.style.opacity = '0'; // Make it invisible
    //     // }

    //     // Show the bottom button again
    //     // const bottomBtn = jobListing.querySelector('.ps-wp-bottom-btn');
    //     // if (bottomBtn) {
    //     //     bottomBtn.style.display = 'block'; // Show the bottom button
    //     // }
    // });

    // // Add a click event to redirect on mouse click
// if (window.innerWidth < 960) {
  const jobEye = jobListing.querySelector('.ps-wp-job-eye');

  if (jobEye) {
    // Make it accessible
    jobEye.setAttribute('tabindex', '0');
    jobEye.setAttribute('role', 'button');
    jobEye.setAttribute('aria-expanded', 'false');

    // Click event
    jobEye.addEventListener('click', function (e) {
      e.stopPropagation(); // Prevent bubbling if needed

      jobListing.classList.toggle('active');

      // Update aria-expanded based on state
      const isActive = jobListing.classList.contains('active');
      jobEye.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    // Optional: add keyboard accessibility
    jobEye.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevent scroll on space
        jobEye.click();     // Trigger the same click behavior
      }
    });
  }
// }



    // Add a keydown event to handle the 'Enter' key for keyboard users
    // jobListing.addEventListener('keydown', function (event) {
    //     if (event.key === 'Enter') {
    //         const jobUrl = jobListing.getAttribute('data-job-url');
    //         window.location.href = jobUrl; // Redirect to job details page
    //     }
    // });
});
}

function makingJoblistingCardClickable(){
    

        const MIN_WIDTH = 960;
        const isWideScreen = window.innerWidth > MIN_WIDTH;
        const listings = document.querySelectorAll('.page-template-joblisting-template .ps-wp-job-listing');

        listings.forEach((listing) => {
            // Always make it keyboard focusable
            listing.setAttribute('tabindex', '0');

            // Remove any previous handlers to prevent duplicate bindings
            if (listing._clickHandler) {
                listing.removeEventListener('click', listing._clickHandler);
            }
            if (listing._keyHandler) {
                listing.removeEventListener('keydown', listing._keyHandler);
            }

            if (isWideScreen) {
                // Define the click handler
                const clickHandler = function (e) {
                    // Avoid hijacking actual <a> links
                    if (!e.target.closest('a')) {
                        const url = listing.getAttribute('data-job-url');
                        if (url) {
                            window.location.href = url;
                        }
                    }
                };

                // Define the keyboard handler (Enter/Space)
                const keyHandler = function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); // Prevent space scrolling
                        const url = listing.getAttribute('data-job-url');
                        if (url) {
                            window.location.href = url;
                        }
                    }
                };

                // Store references for safe removal later
                listing._clickHandler = clickHandler;
                listing._keyHandler = keyHandler;

                listing.addEventListener('click', clickHandler);
                listing.addEventListener('keydown', keyHandler);
            }
        });
    

    



}

    // Re-run on resize
    window.addEventListener('resize', makingJoblistingCardClickable);